import { TrackingDataMap } from '../types/trackingDataModel';

export const DEFAULT_TRACKING_DATA: {
  [K in keyof TrackingDataMap]: TrackingDataMap[K];
} = {
  payback: {
    appId: '',
    salesCode: '',
    sourceCode: '',
    productName: '',
    isSaR: false,
    queryParams: null,
    device: {
      deviceType: '',
      deviceOS: '',
      deviceOSVersion: '',
      deviceBrowser: '',
      deviceBrowserVersion: '',
      deviceScreen: {
        width: 0,
        height: 0,
        pixelRatio: 1,
        orientation: '',
      },
      pbAppVersion: null,
      userAgent: '',
    },
    lastStepIndex: -1,
    steps: null,
  },
};

export const getTenantDataRules = (tenantId: string) => {
  const rules: Record<string, { skipResetOnSubmit?: boolean }> = {
    payback: { skipResetOnSubmit: true },
  };

  return rules[tenantId.toLowerCase()];
};
